import { render, staticRenderFns } from "./ParticipaWidget.vue?vue&type=template&id=238f493e&scoped=true&lang=pug&"
import script from "./ParticipaWidget.vue?vue&type=script&lang=js&"
export * from "./ParticipaWidget.vue?vue&type=script&lang=js&"
import style0 from "./ParticipaWidget.vue?vue&type=style&index=0&id=238f493e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238f493e",
  null
  
)

export default component.exports